/**
 * Navegação: a sequência que a portaria já conhece do TMobi —
 * login → eventos → setores → validador, com a lista/busca de ingressos
 * acessível de dentro do validador.
 *
 * Sem cabeçalho de pilha: cada tela desenha o próprio, porque o cabeçalho
 * carrega informação que só ela tem — o nome do caixa, o estado do sync, o
 * número de ingressos no aparelho.
 */

import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';

import {TelaAberturaCaixa} from './telas/AberturaCaixa';
import {TelaEventos} from './telas/Eventos';
import {TelaFechamentoCaixa} from './telas/FechamentoCaixa';
import {TelaIngressos} from './telas/Ingressos';
import {TelaLogin} from './telas/Login';
import {TelaSetores} from './telas/Setores';
import {TelaValidador} from './telas/Validador';
import {useTema} from './ui/tema';

export type ParamsPilha = {
  Login: undefined;
  Caixa: undefined;
  Eventos: undefined;
  Setores: {eventoId: number; eventoNome: string};
  Ingressos: {eventoId: number; eventoNome: string};
  Fechamento: {eventoId: number; eventoNome: string};
  Validador: {eventoId: number; eventoNome: string; codbarInicial?: string};
};

const Pilha = createNativeStackNavigator<ParamsPilha>();

export function Navegacao({
  inicial,
  evento,
}: {
  inicial: keyof ParamsPilha;
  /** Evento já amarrado ao caixa aberto: o app volta direto para ele. */
  evento?: {eventoId: number; eventoNome: string};
}) {
  const t = useTema();

  return (
    <Pilha.Navigator
      initialRouteName={inicial}
      screenOptions={{
        headerShown: false,
        contentStyle: {backgroundColor: t.fundo},
      }}>
      <Pilha.Screen name="Login" component={TelaLogin} />
      <Pilha.Screen name="Caixa" component={TelaAberturaCaixa} />
      <Pilha.Screen name="Eventos" component={TelaEventos} />
      <Pilha.Screen name="Setores" component={TelaSetores} initialParams={evento} />
      <Pilha.Screen name="Ingressos" component={TelaIngressos} />
      <Pilha.Screen name="Fechamento" component={TelaFechamentoCaixa} />
      <Pilha.Screen name="Validador" component={TelaValidador} />
    </Pilha.Navigator>
  );
}
